// Insignia de origen para formularios sin página en el PDF oficial de la HCU 2021
// (ver lib/formulariosPropios.ts). No dibuja nada para el resto.
import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';
import { CLAVE_INSIGNIA, formularioPropio } from '@/lib/formulariosPropios';

export function InsigniaFormularioPropio({ codigo }: { readonly codigo: string }): JSX.Element | null {
  const { t } = useTranslation();
  const propio = formularioPropio(codigo);
  if (!propio) return null;
  return (
    <Badge variant="outline" className="whitespace-normal" data-testid={`insignia-propio-${codigo}`} data-tipo={propio.tipo}>
      {t(`formulario.${CLAVE_INSIGNIA[propio.tipo]}`, { norma: propio.norma })}
    </Badge>
  );
}
